import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const AlgorithmEfficiencyCases = () => (
  <QPhototModuleSubtopic
    title="Algorithm efficiency, best case, worst case, average case"
    videos={[
      "https://www.youtube.com/embed/5SDaVgotwm4"
    ]}
    takeaways={[
      { text: "mostly theoretical question asked from this topic" }
    ]}
    questions={[
      {image:"/dsa_1.png"},
      { text: "Explain various categories of Asymptotic notations and order of growth with examples" },
      { text: "Give the asymptotic bounds for the equation f(n)=2n^3-6n+30 and represent in terms of θ notation with g(n) as n^3" }
    ]}
    exampleVideos={[]}
  />
);

export default AlgorithmEfficiencyCases;
